<template>
    <div class="build-type-diagram">
        <el-row :gutter="20">
            <!-- 楼栋单元树 -->
            <el-col :span="4">
                <floor-tree ref="floorTree" @switchFloorUnit="switchFloorUnit" />
            </el-col>

            <el-col :span="20">
                <!-- 显示Canvas的卡片 -->
                <el-card class="canvas-card">
                    <div slot="header" class="clearfix">
                        <span>2D平面图展示</span>
                        <el-button style="float: right; padding: 3px 0" type="text" size="small"
                            @click="handleEditCanvas">编辑2D平面图</el-button>
                    </div>
                    <!-- 根据是否有数据显示不同内容 -->
                    <div v-if="hasCanvasData">
                        <canvas-viewer :canvas-data="canvasJsonData" :currentUnitData="currentUnitData" />
                    </div>
                    <div v-else class="no-data-container">
                        <el-empty description="暂无数据"></el-empty>
                    </div>
                </el-card>
            </el-col>
        </el-row>

        <room-layout-edit ref="roomLayoutEdit" @refresh="handleRefresh" />
    </div>
</template>

<script>
import floorTree from '@/components/room/floorTree'
import RoomLayoutEdit from '@/components/room/roomLayoutEdit'
import CanvasViewer from '@/components/room/CanvasViewer'
import { getCommunityId } from '@/api/community/communityApi'
import { queryCanvasData } from '@/api/room/roomApi'


export default {
    name: 'RoomStructureList',
    components: {
        floorTree,
        RoomLayoutEdit,
        CanvasViewer
    },
    data() {
        return {
            communityId: '',
            hasCanvasData: false, // 是否有canvas数据
            canvasJsonData: null,
            currentData: null,
            currentUnitData: null
        }
    },
    created() {
        // 初始化小区ID
        this.communityId = getCommunityId()
        setTimeout(() => {
            this.$refs.floorTree.selectFirstUnit()
        }, 1500)
    },
    methods: {
        // 切换单元
        switchFloorUnit(data) {
            if (!data.unitId) {
                return
            }
            this.currentUnitData = data

            this.handleGetCanvasData(data)
        },

        // 获取 canvas 数据
        async handleGetCanvasData(data) {
            this.currentData = null
            this.hasCanvasData = false // 初始化为无数据状态

            await queryCanvasData({
                unitId: data.unitId
            }).then(res => {
                // 判断是否有数据：检查data属性是否存在且不为空对象
                this.hasCanvasData = res.data !== null &&
                    res.data !== undefined &&
                    Object.keys(res.data).length > 0

                if (this.hasCanvasData) {
                    this.currentData = res.data
                    this.canvasJsonData = res.data.floorUnitDto.canvas
                } else {
                    this.currentData = null
                    this.canvasJsonData = null
                }

            })
        },

        // 编辑 canvas
        handleEditCanvas() {
            this.$nextTick(() => {
                if (this.$refs.roomLayoutEdit) {
                    this.$refs.roomLayoutEdit.open({
                        currentData: this.currentData,
                        currentUnitData: this.currentUnitData,
                        communityId: this.communityId
                    });
                }
            });
        },

        // 刷新数据
        handleRefresh() {
            if (this.currentUnitData) {
                this.handleGetCanvasData(this.currentUnitData);
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.build-type-diagram {
    padding: 20px;
    height: 100%;

    .canvas-card {
        height: calc(80vh);
    }

    .clearfix:before,
    .clearfix:after {
        display: table;
        content: "";
    }

    .clearfix:after {
        clear: both;
    }

    .no-data-container {
        height: 300px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
}
</style>